export default __webpack_public_path__ + "static/media/contact-us.5a00142d.jpg";